import { render, staticRenderFns } from "./StatisticByOrganization.vue?vue&type=template&id=480a4f41&"
import script from "./StatisticByOrganization.vue?vue&type=script&lang=js&"
export * from "./StatisticByOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports